// src/components/ForgotPasswordDialog.js
import React, { useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  TextField, Button, Typography
} from '@mui/material';
import axios from 'axios';

const ForgotPasswordDialog = ({ open, onClose }) => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleSendLink = async () => {
    setError('');
    try {
      await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/auth/forgot-password`, { email });
      setSubmitted(true);
    } catch (err) {
      if (err.response) {
      // Handle known error statuses
      if (err.response.status === 404) {
        setError('No account found with this email.');
      } else if (err.response.status === 500) {
        setError('Server error occurred while unlocking the account.');
      } else {
        setError(err.response.data.message || 'Something went wrong. Please try again.');
      }
    } else {
      // Handle network or unknown errors
      setError('Network error. Please check your connection.');
    }
    }
  };

  const handleClose = () => {
    setEmail('');
    setSubmitted(false);
    setError('');
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Forgot Password</DialogTitle>
      <DialogContent>
        {!submitted ? (
          <>
            <Typography>Please enter your registered email address:</Typography>
            <TextField
              autoFocus
              margin="dense"
              label="Email"
              type="email"
              fullWidth
              variant="standard"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            {error && <Typography color="error" variant="body2">{error}</Typography>}
          </>
        ) : (
          <Typography>
            If this email is registered, a new password has been sent.
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Close</Button>
        {!submitted && <Button onClick={handleSendLink}>Submit</Button>}
      </DialogActions>
    </Dialog>
  );
};

export default ForgotPasswordDialog;
